import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/artofyou/web/personalisation.artofyou.life/public_html/src/page-components/ForgotPassword/ForgotPassword.tsx");
